<template>
  <a-modal
    title="一键导入"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    width="auto"
    centered
    :keyboard="false"
    :maskClosable="false"
    @cancel="handleCancel"
    okText="保存"
    :getContainer="getContainer"
  >
    <div class="content">
      <div class="content1">
        <SelectFile ref="SelectFile" @change="specifiName" />
        <div v-if="p" style="margin-top: 5px">
          已读取有效数据条数：{{ batchArray.length }} 条
        </div>
        <div class="downloadFile" @click="downloadFile">
          <a-icon type="download" style="color: #0073ff" />
          下载模板
        </div>
      </div>
      <div class="content2" v-if="batchArray.length > 0">
        <div>待保存列表：</div>
        <!-- <div>(已存在待保存列表的文件会帮您自动过滤)</div> -->
        <a-list item-layout="horizontal" :data-source="batchArray">
          <a-list-item slot="renderItem" slot-scope="item, index">
            <a-list-item-meta>
              <a slot="title" style="color: #000">单位：{{ item.name }}</a>
              <div slot="description" class="description">
                <div class="left">
                  <div>{{ item.code }}</div>
                  <div>法人：{{ item.legal_person }}</div>
                </div>
                <div class="del">
                  <a @click="delFile(index)">
                    <a-icon
                      type="close-circle"
                      style="color: red; font-size: 18px"
                    />
                  </a>
                </div>
              </div>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { handleFileUpload, saveExcel } from "@/utils/os";
import { companyFileBatch } from "@/utils/exportFile";
import { isDateOrDateTime, excelTimeFormat } from "@/utils/util";
import SelectFile from "@/components/SelectFile/index";
import { batchAdd } from "@/request/company";
export default {
  components: { SelectFile },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      p: "",
      batchArray: [],
    };
  },
  methods: {
    init() {
      this.visible = true;
    },
    //选择的文件地址回调
    specifiName($event) {
      console.log("选择的文件地址回调");
      //   const hide = this.$message.loading("读取中···", 0);
      this.p = document.getElementById("open").files[0].path;
      const is_ = this.isTableFile(this.p);
      if (!is_) {
        $event.srcElement.value = ""; //及时清空
        return this.$message.warning("请选择 .xlsx、.xls 或 .csv 结尾的文件");
      }
      handleFileUpload($event).then((jsonData) => {
        jsonData.splice(0, 1);
        console.log(jsonData);
        let ok = [];
        for (let i = 0; i < jsonData.length; i++) {
          let obj = jsonData[i];
          let is_ok = true;
          for (let k = 0; k < obj.length; k++) {
            const item = obj[k];
            const must = companyFileBatch[k].must; //当前数据是否必填
            if (!item && must) is_ok = false;
            continue;
          }
          //校验通过的数据
          if (is_ok) {
            console.log("有");
            let a = {};
            let specialRule = true;
            for (let index = 0; index < companyFileBatch.length; index++) {
              const v = companyFileBatch[index];
              if (v.cellDates) {
                //是否有日期格式数据
                const time = !!obj[index]
                  ? excelTimeFormat(obj[index], "YYYY-MM-DD")
                  : "";
                console.log("日期", time);
                // if (isDateOrDateTime(time) === false) {
                //   specialRule = false;
                // } else {
                //   a[v.key] = time;
                // }
                if (isDateOrDateTime(time) === true) {
                  a[v.key] = time;
                }
              } else {
                a[v.key] = obj[index];
              }
            }
            if (specialRule) ok.push(a);
          }
        }
        console.log(ok);
        this.$message.success("读取成功");
        this.batchArray = ok;
      });
      $event.srcElement.value = ""; //及时清空
    },
    isTableFile(url) {
      // 在正则表达式中使用 $ 表示字符串的结尾
      var regex = /\.xlsx$|\.xls$|\.csv$/i; // 匹配 .xlsx、.xls 或 .csv 结尾的文件
      return regex.test(url);
    },
    handleOk() {
      if (!this.p) return this.$message.warning("请选择上传文件");
      if (this.batchArray.length == 0)
        return this.$message.warning("请导入有效数据");
      this.confirmLoading = true;
      batchAdd({ array: this.batchArray })
        .then((res) => {
          this.p = "";
          this.batchArray = [];
          const h = this.$createElement;
          this.$success({
            title: "导入操作结果",
            getContainer: () => document.getElementById("bodyContnet"),
            // JSX support
            content: h("div", {}, [
              h("div", "成功导入数据条数：" + res.data.affectedRows),
              h(
                "div",
                "失败导入数据条数：" +
                  res.data.warningCount +
                  "(当前项目下单位名称已存在)"
              ),
            ]),
          });
        })
        .finally(() => {
          this.confirmLoading = false;
          this.$emit("ok");
        });
    },
    handleCancel() {
      this.visible = false;
      this.batchArray = [];
    },
    //删除上传的文件
    delFile(index) {
      this.batchArray.splice(index, 1);
    },
    downloadFile() {
      const data = {};
      companyFileBatch.forEach((v) => {
        data[v.value] = "";
      });
      saveExcel([data], "分包单位导入模板");
    },
    getContainer() {
      return document.getElementById("bodyContnet");
    },
  },
};
</script>

<style scoped>
.downloadFile {
  font-size: 12px;
  color: #011733;
  margin-top: 15px;
  cursor: pointer;
  display: inline-block;
}
.content {
  display: flex;
}
.content1 {
  width: 100%;
  min-width: 400px;
  max-width: 400px;
}
.content2 {
  width: 300px;
  margin-left: 20px;
  max-height: 80vh;
  overflow-y: auto;
}

.description {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.left {
  width: 80%;
}
</style>